import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './Layout.js';
import { BudgetPage } from './pages/Budget.js';
import { DocumentsPage } from './pages/Documents.js';
import { ObligationsPage } from './pages/Obligations.js';
import { PeoplePage } from './pages/People.js';
import { TravelPage, TripPage } from './pages/Travel.js';
import { VaultPage } from './pages/Vault.js';
import { TodayPage } from './pages/Today.js';

export function App() {
  return (
    <Routes>
      <Route element={<Layout appName="Almanac" tagline="A quieter way to manage a life." />}>
        <Route index element={<TodayPage />} />
        <Route path="obligations" element={<ObligationsPage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="people" element={<PeoplePage />} />
        <Route path="vault" element={<VaultPage />} />
        <Route path="budget" element={<BudgetPage />} />
        <Route path="travel" element={<TravelPage />} />
        <Route path="travel/:tripId" element={<TripPage />} />
        {/* Catch-all: any path the SPA shell gets served for but has no
            route for (a stale deep link, an edge URL that slipped
            through) lands on Today instead of a blank page. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
